import { INode } from 'shared/types/tree'
import { atom } from 'infrastructure/state/jotai.wrapper'

export type TreesState = {
  treesById: { [id: string]: INode | undefined }
  retrievingTrees: string[]
  retrievedTrees: string[]
}

export enum ActionType {
  RetrievingTree,
  RetrievedTree,
  ResetTree,
}

type RetrievingTree = {
  type: ActionType.RetrievingTree
  treeId: string
  versionId: string
}

type RetrievedTree = {
  type: ActionType.RetrievedTree
  tree?: INode
  treeId: string
  versionId: string
}

type ResetTree = {
  type: ActionType.ResetTree
  treeId: string
  versionId: string
}

type Action = RetrievingTree | RetrievedTree | ResetTree

export const treesStateAtom = atom<TreesState>({
  retrievedTrees: [],
  retrievingTrees: [],
  treesById: {},
})

export const treesReducer = (state: TreesState, action: Action) => {
  switch (action.type) {
    case ActionType.ResetTree: {
      const tid = `${action.treeId}:${action.versionId}`
      return {
        ...state,
        retrievedTrees: state.retrievedTrees.filter((id) => id !== tid),
        retrievingTrees: state.retrievingTrees.filter((id) => id !== tid),
        treesById: {
          ...state.treesById,
          [tid]: undefined,
        },
      }
    }
    case ActionType.RetrievingTree:
      return {
        ...state,
        retrievingTrees: [
          ...state.retrievingTrees,
          `${action.treeId}:${action.versionId}`,
        ],
      }
    case ActionType.RetrievedTree: {
      const tid = `${action.treeId}:${action.versionId}`
      const retrievedTrees = state.retrievedTrees.includes(tid)
        ? state.retrievedTrees
        : [...state.retrievedTrees, tid]
      return {
        ...state,
        retrievingTrees: state.retrievingTrees.filter((id) => id !== tid),
        retrievedTrees,
        treesById: {
          ...state.treesById,
          [tid]: action.tree,
        },
      }
    }
  }
}

export const treesDispatchAtom = atom<null, [Action], void>(
  null,
  (get, set, action) => {
    set(treesStateAtom, (prev) => treesReducer(prev, action))
  },
)
